"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnchainRewardsTotalToJSON = exports.BurnchainRewardsTotalFromJSONTyped = exports.BurnchainRewardsTotalFromJSON = void 0;
function BurnchainRewardsTotalFromJSON(json) {
    return BurnchainRewardsTotalFromJSONTyped(json, false);
}
exports.BurnchainRewardsTotalFromJSON = BurnchainRewardsTotalFromJSON;
function BurnchainRewardsTotalFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reward_recipient': json['reward_recipient'],
        'reward_amount': json['reward_amount'],
    };
}
exports.BurnchainRewardsTotalFromJSONTyped = BurnchainRewardsTotalFromJSONTyped;
function BurnchainRewardsTotalToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reward_recipient': value.reward_recipient,
        'reward_amount': value.reward_amount,
    };
}
exports.BurnchainRewardsTotalToJSON = BurnchainRewardsTotalToJSON;
//# sourceMappingURL=BurnchainRewardsTotal.js.map